import styled from 'styled-components';

const Thumbnails = styled.div`
  display: flex;
  justify-content: center;
`;

export default Thumbnails;
